import React from "react";
import clsx from "clsx";
import { Hidden } from "@material-ui/core";
import { map, startCase } from "lodash";
import { useSelector } from "react-redux";

import normaliseDateTime from "app/main/patients/helpers/normalise-date-time";
import { getReferralWorkflowStateSettings } from "app/auth/store/reducers/system-configuration";
import useTriageFieldSettings from "app/main/referrals/hooks/useTriageFieldSettings";
import PatientReferralsListItem from "app/main/patients/referrals/components/patient-referrals-item";
import { AppointmentIcon } from "helpers/icon-finder";
import { AppointmentDateItem, AppointmentListItemContent } from "./appointment-list-item-content";

const AppointmentListItem = ({
  assignedBy,
  item: {
    patientId,
    startDateTimeUtc,
    status,
    locationDisplayValue,
    details,
  },
  appointmentReferrals,
  orgUnitId,
  isFirst,
}) => {
  const referralWorkflowSettings = useSelector(getReferralWorkflowStateSettings);
  const appointmentDate = normaliseDateTime(startDateTimeUtc, true);
  const { fieldLabels: triageFieldLabels } = useTriageFieldSettings(orgUnitId);

  const appointmentItem = (
    appointmentDetails,
    appointmentLocation,
    appointmentStatus,
    scheduledAppointmentDate,
    appointmentStatusAssignedBy,
  ) => (
    <AppointmentListItemContent
      title={appointmentLocation}
      status={
        startCase(appointmentStatus)
      }
      dateAndBy={
        <AppointmentDateItem date={scheduledAppointmentDate} name={appointmentStatusAssignedBy} />
      }
      appointmentType={
        appointmentDetails
      }
    />
  );

  const renderAppointmentReferrals = (referrals, signedInOrgUnit) => (
    map(referrals, (referral, index) => (
      <PatientReferralsListItem
        key={referral.id}
        orgUnitId={referral.orgUnitId}
        isFirst={index === 0}
        referral={referral}
        patientId={patientId}
        fromUrl={`/referralWorklist/patient/${patientId}`}
        referralWorkflowSettings={referralWorkflowSettings}
        triageFieldLabels={triageFieldLabels}
        disabled={referral.orgUnitId !== signedInOrgUnit}
      />
    ))
  );

  return (
    <>
      <div className={clsx("flex", !isFirst && "with-horizontal-divider", isFirst && "mt-16")}>
        <Hidden smDown>
          <AppointmentIcon className="w-40 mr-8" size={32} />
        </Hidden>
        <div className="flex-auto">
          <div className="flex-row-container">
            <div className="flex-1 enable-shrink">
              {appointmentItem(details, locationDisplayValue, status, appointmentDate, assignedBy)}
            </div>
          </div>
        </div>
      </div>
      <div>
        {appointmentReferrals && renderAppointmentReferrals(appointmentReferrals, orgUnitId)}
      </div>
    </>
  );
};

export default AppointmentListItem;
